import React from "react";
import PropTypes from "prop-types";
import Breadcrumb from "./Breadcrumb";
import StatsBar from "./StatsBar";
import { buildScopeTranslate } from "lib/I18n";
import { refPropType } from "../utils";

const tIntro = buildScopeTranslate("views.content.agentforce.assessments.pages.intro");
const tLabels = buildScopeTranslate("views.content.agentforce.assessments.labels");

const IntroScreen = ({ attempt, onStartQuiz, onBackToTrail, onInfoClick, onFeedbackClick = null, showFeedbackButton = false, headingRef = null }) => {
  if (!attempt) {
    return null;
  }

  const questionCount = attempt.questions.length;
  const { topic } = attempt;
  const passingScore = Math.round(topic.scoreThreshold);
  const isScoreThresholdRequired = topic.scoreThresholdRequired || false;
  const scoreLabel = isScoreThresholdRequired
    ? tLabels("required_score", { score: passingScore })
    : tLabels("suggested_score", { score: passingScore });

  return (
    <>
      <Breadcrumb showProgress={false} onBackClick={onBackToTrail} onInfoClick={onInfoClick} onFeedbackClick={onFeedbackClick} showFeedbackButton={showFeedbackButton} />
      <div className="th-agentforce-assessment__header-section">
        <div className="slds-container_center slds-container_medium th-agentforce-assessment__header-content">
          <div className="slds-text-align_center">

            <h1
              ref={headingRef}
              className="slds-text-heading_large slds-m-bottom_medium th-agentforce-assessment__heading"
              data-testid="intro-heading"
              tabIndex="-1">
              {tIntro("title")}
            </h1>

            <p
              className="slds-text-body_regular slds-m-bottom_large th-agentforce-assessment__text-subtle"
              data-testid={isScoreThresholdRequired ? 'intro-description-required' : 'intro-description-suggested'}>
              {isScoreThresholdRequired
                ? tIntro("required_subtitle")
                : tIntro("suggested_subtitle")}
            </p>

            <StatsBar
              data-testid={isScoreThresholdRequired ? 'intro-stats-required' : 'intro-stats-suggested'}
              items={[
                { icon: 'custom48', sprite: 'custom', text: tLabels("questions_count", { count: questionCount }) },
                { icon: 'success', text: scoreLabel },
                { icon: 'clock', text: tLabels("estimated_time", { time: topic.minutesToComplete }) },
              ]} />
          </div>
        </div>
      </div>
      <div className="slds-container_center slds-container_medium th-agentforce-assessment__intro">
        <div className="slds-text-align_center th-agentforce-assessment__preamble">
          <tds-button variant="brand" onClick={onStartQuiz} data-testid="intro-start-btn">
            <span>{tIntro("buttons.primary")}</span>
          </tds-button>
        </div>
        <div className="th-agentforce-assessment__preamble">
          {topic.preamble && (
            <div className="slds-text-body_regular slds-m-vertical_xx-large" data-testid="intro-preamble">
              {topic.preamble.split(/\n+/).filter(line => line.trim()).map((paragraph, index) => (
                <p key={index} className="slds-m-bottom_small">{paragraph}</p>
              ))}
            </div>
          )}
          {/* eslint-disable-next-line react/no-danger */}
          <p
            className="slds-text-body_small slds-m-top_medium th-agentforce-assessment__text-subtle"
            dangerouslySetInnerHTML={{ __html: tIntro("legal_copy") }}
          />
        </div>
      </div>
    </>
  );
};

IntroScreen.propTypes = {
  attempt: PropTypes.shape({
    questions: PropTypes.arrayOf(PropTypes.object).isRequired,
    topic: PropTypes.shape({
      preamble: PropTypes.string,
      scoreThreshold: PropTypes.number.isRequired,
      scoreThresholdRequired: PropTypes.bool,
      minutesToComplete: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  onStartQuiz: PropTypes.func.isRequired,
  onBackToTrail: PropTypes.func.isRequired,
  onInfoClick: PropTypes.func.isRequired,
  onFeedbackClick: PropTypes.func,
  showFeedbackButton: PropTypes.bool,
  headingRef: refPropType,
};

export default IntroScreen;
